export const enum Language {
  zhCN = 'zh-CN',
  enUS = 'en-US',
  idID = 'id-ID',
  thTH = 'th-TH',
  msMY = 'ms-MY',
  esES = 'es-ES',
  viVN = 'vi-VN'
}

export function isValidLanguage(lang?: string): lang is Language {
  if (!lang) {
    return false
  }

  return (
    [
      Language.enUS,
      Language.zhCN,
      Language.idID,
      Language.thTH,
      Language.msMY,
      Language.esES,
      Language.viVN
    ] as string[]
  ).includes(lang)
}
